// Lib
import React from 'react';
import { Typography } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';

// Components
import Input from '../../../components/Field/Input';
import Layout from '../../../components/Layout';
import Button from '../../../components/Button';
import Feather from '../../../components/Feather';

// Hooks
import useAuth from '../hooks/useAuth';

// Validation
import { usernameValidation, passwordValidation } from '../validationRules';

import { useStyles } from './LoginStyles';

const Login = () => {
  const { classes } = useStyles();
  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      username: '',
      password: '',
    },
  });
  const { changeType, type, onSubmit, onChange, apiError, isLoading } =
    useAuth();

  return (
    <Layout className={{ layout: classes.layout }}>
      <form onSubmit={handleSubmit(onSubmit)} className={classes.root}>
        <Typography className={classes.header} align="center" variant="h1">
          Log In
        </Typography>
        <Controller
          name="username"
          rules={usernameValidation}
          control={control}
          render={({ field }) => (
            <Input
              id="username"
              label="Username"
              className={classes.input}
              {...field}
              onChange={onChange(field.onChange)}
            />
          )}
        />
        <Controller
          name="password"
          rules={passwordValidation}
          control={control}
          render={({ field }) => (
            <Input
              id="password"
              label="Password"
              type={type}
              className={classes.password}
              InputProps={{
                classes: { root: classes.root },
                endAdornment: (
                  <Feather
                    nativeColor
                    onClick={changeType}
                    type={type === 'password' ? 'closedEye' : 'openedEye'}
                  />
                ),
              }}
              {...field}
              onChange={onChange(field.onChange)}
            />
          )}
        />
        {apiError && (
          <div className={classes.error} data-testid="login-error-message">
            {apiError}
          </div>
        )}
        <Button
          type="submit"
          loadingIndicator="Loading…"
          loading={isLoading}
          id="log-in-button"
          disabled={!isValid}
          onClick={handleSubmit(onSubmit)}
          className={classes.button}>
          Log In
        </Button>
      </form>
    </Layout>
  );
};

export default Login;
